const b = (t, s = 1) => {
  const o = t.charAt(0) === "#" ? t.substring(1) : t, n = parseInt(o, 16), c = n >> 16 & 255, r = n >> 8 & 255, a = n & 255;
  return { r: c, g: r, b: a, a: s };
};
export {
  b as hexToRgb
};
//# sourceMappingURL=index3.js.map
